import React, {  useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { MenuList } from "../../layouts/nav/Menu";

const AllMenuPages = () => {
    const [searchTerm, setSearchTerm] = useState("");

    


    const filteredMenu = MenuList.map((item) => ({
        ...item,
        content: item.content.filter((subItem) =>
          subItem.title.toLowerCase().includes(searchTerm.toLowerCase())
        ),
      })).filter((item) => item.content.length > 0); 
 
     
      return (
        <div className="dlabnav-scroll  " style={{height:"90vh",position: "fixed",marginTop:"20px", zIndex: "50", width: "80vw", overflowX:"hidden"}}>
          <div style={{ marginTop: "35px", textAlign: "center" }}>
            <input
              type="text"
              placeholder="Search ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "40%",
                padding: "8px",
                fontSize: "14px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                outline: "none",
              }}
            />
          </div>
    
          <ul className="metismenu" id="menu" style={{ listStyleType: "none", padding: 0, margin: 0 }}>
            {filteredMenu.length > 0 ? (
              filteredMenu.map((item, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                  <h4 style={{  borderBottom: "3px solid orange",  display: "inline-block", paddingBottom: "5px", fontSize: "18px", fontWeight: "bold",  }}  >
                    {item.title}
                  </h4>
    
                  <ul
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                      gap: "10px",
                      padding: 0,
                      marginTop: "10px",
                      listStyleType: "none",
                    }}
                  >
                    {item.content.map((subItem, subIndex) => (
                      <li key={subIndex} style={{ fontSize: "14px", fontWeight: "500" }}>
                        <Link
                          to={`/${subItem.to}`}
                          style={{
                            textDecoration: "none",
                            color: "#333",
                            paddingBottom:"100px",
                            transition: "color 0.3s ease-in-out",
                          }}
                          onMouseEnter={(e) => (e.target.style.color = "#17a2b8")}
                          onMouseLeave={(e) => (e.target.style.color = "#333")}
                        >
                          {subItem.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <p style={{ textAlign: "center", fontSize: "14px", fontWeight: "500" }}>No results found</p>
            )}
          </ul>
        </div>
      );
      
    };

export default AllMenuPages;
